import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import { collectionsDuck } from '@eb/redux-destination';

import events from './events/index';
import collection from './collection';
import ui from './ui';

import { SET_LOADING, SET_ERROR, CLEAR_ERROR } from '../actions';

const isLoading = (state = false, { type, payload }) => {
    let newState = state;

    if (type === SET_LOADING) {
        newState = payload;
    }

    return newState;
};

const hasError = (state = false, { type }) => {
    let nextState = state;

    if (type === SET_ERROR) {
        nextState = true;
    }

    if (type === CLEAR_ERROR) {
        nextState = false;
    }

    return nextState;
};

export default combineReducers({
    ui,
    form,
    isLoading,
    hasError,
    routing,
    collection,
    events,
    collections: collectionsDuck.reducer,

    domain: (state = '') => state,
    currencyFormat: (state = '') => state,
    shareOptions: (state = {}) => state,
    featureFlags: (state = {}) => state,
    userId: (state = '') => state,
    gaSettings: (state = {}) => state,
    isAuthenticated: (state = false) => state,
    isGDPRCountry: (state = true) => state,
});
